export const isNestedObjectTruthy = obj => {
  const {__v, ...rest} = obj;
  if (Object.keys(rest).length === 0) {
    return false;
  }
  for (const [_, value] of Object.entries(rest)) {
    if (value && typeof value === 'object') {
      if (Object.keys(value).length === 0) {
        return false;
      }
      if (!isNestedObjectTruthy(value)) {
        return false;
      }
    } else if (!value && value !== 0) {
      return false;
    }
  }
  return true;
};

export function isNestedObjectValuesTruthy(obj) {
  if (obj === null || typeof obj !== 'object') {
    return false;
  }

  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

    const value = obj[key];

    const isPrimitive = val => val !== Object(val);
    if (isPrimitive(value) && Boolean(value)) {
      return true;
    }

    if (typeof value === 'object' && isNestedObjectValuesTruthy(value)) {
      return true;
    }
  }

  return false;
}
